import { withRecoverableErrorBoundary as withRecoverableErrorBoundaryImpl } from '@jira/platform__recoverable-error-boundary/src/withRecoverableErrorBoundary.tsx';

/** *
 * @deprecated Use `@jira/platform__recoverable-error-boundary` instead
 */
export const withRecoverableErrorBoundary = withRecoverableErrorBoundaryImpl;
